import { ImResponse, doorClient, leyanbotClient, resolve, storeHomeNVClient } from 'services/api';

export function groupList() {
  return resolve(
    doorClient.get<ImResponse<Knowledge.Group[]>>('/knowledge/common_knowledges/knowledge_groups'),
  );
}

export function resetCommonKnowledges(body: { definitionCode: Knowledge.KnowledgeType }) {
  return doorClient.post('/knowledge/common_knowledges/knowledge_values/reset', body);
}

export function getCommonKnowledges(definitionCode: Knowledge.KnowledgeType) {
  return resolve(
    doorClient.get<ImResponse<any[]>>('/knowledge/common_knowledges/knowledge_values', {
      params: {
        definition_code: definitionCode,
      },
    }),
  );
}

/**
 * 获取模版的默认值的时候有用
 * @param definitionCode
 */
export function queryTemplate(definitionCode: Knowledge.KnowledgeType) {
  return resolve<CommonKnowledge.Template[]>(
    doorClient.get('/knowledge/common_knowledges/knowledge_templates', {
      params: {
        definitionCode,
      },
    }),
  );
}

/**
 * 批量编辑模版知识值
 */
export function batchUpdateKnowledgeContent(body: {
  items: { id: number; content: string; templateCode: string }[];
}) {
  return doorClient.put('/knowledge/common_knowledges/knowledge_values/content', body);
}

// 裁剪字段
export function checkCommonKnowledge(body: any) {
  return resolve<Knowledge.KnowledgeItem[]>(
    doorClient.post('/knowledge/common_knowledges/knowledge_values/check_overwrite', body),
  );
}

export function createCommonKnowledge(body: any) {
  return doorClient.post<ImResponse<any>>('/knowledge/common_knowledges/knowledge_values', body);
}

export function editCommonKnowledge(body: any) {
  return doorClient.put('/knowledge/common_knowledges/knowledge_values', body);
}

// *********************** presetTime start ********************
export function getPresetTimeList() {
  return resolve(
    doorClient.get<ImResponse<Knowledge.PresetTimes>>('/knowledge/common_knowledges/sepecial_dt'),
  );
}

export function createPresetTime(body: Knowledge.PresetTime) {
  return doorClient.post('/knowledge/common_knowledges/sepecial_dt', body);
}

export function editPresetTime(body: Knowledge.PresetTime) {
  return doorClient.put('/knowledge/common_knowledges/sepecial_dt', body);
}

export function deletePresetTime(id: number) {
  return doorClient.delete(`/knowledge/common_knowledges/sepecial_dt?id=${id}`);
}
// *********************** presetTime  end *********************

export function relatedScenarios({
  lang,
  ...params
}: {
  knowledgeCode: Knowledge.KnowledgeType;
  lang: General.SystemLanguage;
}) {
  return storeHomeNVClient
    .get<Knowledge.Related.Scenario[]>('/api_gateway/policy/knowledge/scenario', {
      params,
      headers: { lang: lang === 'zh-CN' ? 'zh-CN' : 'en' },
    })
    .then((res) => res.data);
}

export interface RelatedPolicysParams {
  scenarioName: string;
  policyName: string;
  lang: General.SystemLanguage;
  knowledgeCode: Knowledge.KnowledgeType;
}

export function relatedPolicys({ lang, ...params }: RelatedPolicysParams) {
  return storeHomeNVClient
    .get<Knowledge.Related.Policy[]>('/api_gateway/policy/knowledge/policy', {
      params,
      headers: { lang: lang === 'zh-CN' ? 'zh-CN' : 'en' },
    })
    .then((res) => res.data);
}

export interface NotConfigStore {
  storeId: number;
  platform: string;
  region: string;
  shopId: string;
  storeName: string;
  alias: string;
  storeType: 'LOCAL' | 'CROSS';
  is3pf: boolean;
}

// 获取未配置知识点的店铺
export function getKnowledgeNotConfigStores(definitionCode: Knowledge.KnowledgeType) {
  return resolve(
    leyanbotClient.get<ImResponse<NotConfigStore[]>>(
      '/oversea-knowledge/knowledge/no_config_stores',
      {
        params: {
          definition_code: definitionCode,
        },
      },
    ),
  );
}

// 清空店铺范围的某个知识点的值并设置为新的值
// https://app.apifox.com/link/project/625489/apis/api-142867525
export function knowledgeRecreate(data: any) {
  return leyanbotClient.post<ImResponse<any>>('/oversea-knowledge/knowledge/recreate', data);
}

export function logisticsKnowledgeRecreate(data: {
  type: 'UPDATE' | 'ADD';
  knowledges: {
    groupId: number;
    [x: string]: any;
  }[];
}) {
  return leyanbotClient.post<ImResponse<any>>(
    '/oversea-knowledge/knowledge/recreate_by_group',
    data,
  );
}

// 检测语言
export function detectLanguage(data: string[]) {
  return resolve<{
    languageCode: string[];
  }>(
    leyanbotClient.post('/courier/language_detection', {
      texts: data,
    }),
  );
}

export function getStoreGroupList() {
  return resolve(
    leyanbotClient.get<ImResponse<Knowledge.StoreGroup[]>>('/oversea-knowledge/store_group/list'),
  );
}

export function createStoreGroup(body: Omit<Knowledge.StoreGroup, 'id'>) {
  return leyanbotClient.post('/oversea-knowledge/store_group/insert', body);
}

export function updateStoreGroup(body: Knowledge.StoreGroup) {
  return leyanbotClient.post('/oversea-knowledge/store_group/update_single', body);
}

export function updateStoreGroupListBootGuide(body: { storeGroupList: Knowledge.StoreGroup[] }) {
  return leyanbotClient.post('/oversea-knowledge/store_group/update', body);
}

export function deleteStoreGroup(id: number | string) {
  return leyanbotClient.post(`/oversea-knowledge/store_group/del/${id}`, null);
}

export function updateKnowledgeStatus(
  body:
    | { definitionCode: Knowledge.KnowledgeType; status: boolean }
    | { definitionCodes: Knowledge.KnowledgeType[]; status: boolean },
) {
  return leyanbotClient.post('/oversea-knowledge/knowledge/update_status', body);
}
